import { t, useLanguage } from "@/i18n/LanguageContext";import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 28, className = "" }) {useLanguage();
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}>
      
      {t(children)}
    </motion.div>);

}

export function Eyebrow({ children, light = false }) {useLanguage();
  return (
    <p
      className={`font-mono text-xs uppercase tracking-[0.3em] ${
      light ? "text-brand-lime" : "text-brand-navy"}`
      }>
      
      {t(children)}
    </p>);

}

export function DecorativeStripe({ testId }) {useLanguage();
  return (
    <div aria-hidden="true" data-testid={testId} className="pointer-events-none absolute inset-x-0 bottom-0 select-none">
      <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 sm:px-6 lg:px-8">
        <span className="block h-0.5 w-32 bg-brand-amber sm:w-48" />
        <span className="block h-px w-8 bg-brand-amberdark sm:w-12" />
      </div>
    </div>);

}
